import {client} from '@core/GraphQLProvider';
import {
    GetCustomerEquipment,
    GetRmasByAccountNumber,
    GetRepairsCart,
    AddRepairItem,
    RemoveRepairItem,
    UpdateRepairsCart,
    CreateRmaRequest,
    GetCustomerAddresses,
    GetSmsUpsLabel
} from './query.graphql';

if (process.env.MOCK_API == 1) {
    require('./mocks');
}

const SmsService = {
    // todo -> refactor all calls/tests to return "resp" object only
    async getCustomerEquipment () {
        const resp = await client.query( {
            query: GetCustomerEquipment
        } );

        return resp.data.customerEquipment;
    },

    async getRmasByAccountNumber () {
        const resp = await client.query( {
            query: GetRmasByAccountNumber
        } );

        return resp.data.rmasByAccountNumber;
    },

    async getCustomerAddresses () {
        const resp = await client.query( {
            query: GetCustomerAddresses
        } );

        return resp.data.smsAddressesByAccountNumber;
    },

    async getSmsUpsLabel ( trackingNumber ) {
        const resp = await client.query( {
            query: GetSmsUpsLabel,
            variables: {trackingNumber}
        } );

        return resp.data.smsUpsLabel;
    },

    async createRmaRequest ( input ) {
        const resp = await client.mutate( {
            mutation: CreateRmaRequest,
            variables: {input}
        } );

        return resp.data.createRmaRequest;
    },

    getRepairsCart () {
        return client.query( {
            query: GetRepairsCart
        } );
    },

    addRepairItem ( input ) {
        return client.mutate( {
            mutation: AddRepairItem,
            variables: {
                input: {
                    ...input,
                    __typename: 'SmsProduct'
                }
            }
        } );
    },

    removeRepairItem ( input ) {
        return client.mutate( {
            mutation: RemoveRepairItem,
            variables: {
                input: {
                    ...input,
                    __typename: 'SmsProduct'
                }
            }
        } );
    },

    clearRepairsCart ( input ) {
        return client.mutate( {
            mutation: UpdateRepairsCart,
            variables: {input}
        } );
    }

};

export default SmsService;

